import React from 'react';

interface PanelProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg' | 'none'; // p-4, p-6, p-8
  borderRadius?: 'sm' | 'md' | 'lg' | 'xl' | 'panel' | 'button';
  border?: boolean;
  style?: React.CSSProperties;
}

const Panel: React.FC<PanelProps> = ({
  children,
  className = '',
  padding = 'md',
  borderRadius = 'panel',
  border = false,
  style = {},
}) => {
  const paddingMap = {
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    none: '0',
  };

  const borderRadiusMap = {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    panel: '1rem',
    button: '0.5rem',
  };

  const panelStyle: React.CSSProperties = {
    background: 'rgba(15, 23, 42, 0.9)', // Dark slate with transparency
    backdropFilter: 'blur(16px)',
    border: border ? '1px solid rgba(59, 130, 246, 0.3)' : 'none',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(59, 130, 246, 0.1)',
    padding: paddingMap[padding],
    borderRadius: borderRadiusMap[borderRadius],
    color: '#dbeafe', // Light blue text
    position: 'relative',
    overflow: 'hidden',
    ...style,
  };

  return (
    <div className={className} style={panelStyle}>
      {/* Subtle glow effect overlay */}
      <div 
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to right, rgba(37, 99, 235, 0.05), rgba(147, 51, 234, 0.05), rgba(99, 102, 241, 0.05))',
          borderRadius: borderRadiusMap[borderRadius],
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />
      
      {/* Content */}
      <div style={{ position: 'relative', zIndex: 1 }}>
      {children}
      </div>
    </div>
  );
};

export default Panel; 